export default __webpack_public_path__ + "static/media/heroMobile.e213fdd6.png";